module.exports = __webpack_public_path__ + "static/media/noun-in-progress-556632-FFFFFF.989d5171.svg";